import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import StoreIcon from '@mui/icons-material/Store';
import Box from "@mui/material/Box";
import siteLogo from '../../../logos/siteLogo.png';
import { setTruInkSelectedSiteLogout } from '../../../redux/slices/truInk';
import { useDispatch } from 'react-redux';
import Typography from "@mui/material/Typography";

function TruInkSelectedSiteHeader({ selectedSite }) {
      const dispatch = useDispatch();

      return (
            <>
                  <Box
                        className="selected-site-mobile-header"
                  >
                        <Box
                              className="selected-site-mobile-header-left-box"
                        >
                              <ArrowBackIosIcon
                                    className="selected-site-mobile-header-back-button"
                                    onClick={() => {
                                          dispatch(setTruInkSelectedSiteLogout());
                                    }}
                              />
                              <Box
                                    sx={{
                                          backgroundImage: `
          linear-gradient(rgba(105, 30, 45, 0.7), rgba(105, 30, 45, 0.7)),
          url(${siteLogo})
        `,
                                    }}
                                    className="selected-site-mobile-header-icon-container"
                              >
                                    <StoreIcon   className="selected-site-mobile-header-icon" />
                              </Box>
                        </Box>

                        <Box
                              className="selected-site-mobile-header-right-box"
                        >
                              <Box
                                    className="selected-site-mobile-header-site-side-info-container"
                              >
                                    <Typography
                                          className="selected-site-mobile-header-selected-site-name"
                                    >
                                          {selectedSite.name}
                                    </Typography>
                                    <Typography
                                           className="selected-site-mobile-header-selected-site-location"
                                    >
                                          {selectedSite.location}
                                    </Typography>
                                    <Typography
                                           className="selected-site-mobile-header-selected-site-id"
                                    >
                                          {selectedSite.id}
                                    </Typography>
                              </Box>

                              <Typography
                                     className="selected-site-mobile-header-selected-site-heading"
                              >
                                    Welcome to the world of digital labels!
                              </Typography>
                              <Typography
                                     className="selected-site-mobile-header-selected-site-subheading"
                              >
                                    This is what smart sustainability looks like.
                              </Typography>
                        </Box>
                  </Box>







                  <Box
                        sx={{
                              width: "100%",
                              display: { xs: "none", md: "flex" },
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: 2,
                              boxSizing: "border-box",
                              overflow: "hidden",
                        }}
                  >
                        <Box
                              sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: {
                                          sm: "6px",
                                          md: "1vw",
                                    },
                                    cursor: "pointer",
                                    justifyContent: {
                                          sm: "start",
                                          md: "center",
                                    },
                                    width: {
                                          sm: "auto",
                                          md: "auto",
                                    },
                                    minWidth: 0,
                                    flexShrink: 1,
                              }}
                        >
                              <ArrowBackIosIcon
                                    sx={{
                                          cursor: "pointer",
                                          flexShrink: 0,
                                          height: {
                                                sm: "4vh",
                                                md: "5vh",
                                          },
                                          width: {
                                                sm: "4vh",
                                                md: "5vh",
                                          },
                                    }}
                                    onClick={() => {
                                          dispatch(setTruInkSelectedSiteLogout());
                                    }}
                              />

                              <Box
                                    sx={{
                                          p: { sm: "0.8rem", md: "1rem" },
                                          border: "1px solid #ccc",
                                          borderRadius: {
                                                sm: "8px",
                                                md: "1.5vw",
                                          },
                                          width: {
                                                sm: "14vw",
                                                md: "6vw",
                                          },
                                          height: {
                                                sm: "14vw",
                                                md: "6vw",
                                          },
                                          maxWidth: {
                                                sm: "80px",
                                                md: "none",
                                          },
                                          maxHeight: {
                                                sm: "80px",
                                                md: "none",
                                          },
                                          marginRight: { sm: 1, md: 2 },
                                          flexShrink: 0,
                                          backgroundImage: `
            linear-gradient(rgba(105, 30, 45, 0.7), rgba(105, 30, 45, 0.7)),
            url(${siteLogo})
          `,
                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          color: "white",
                                          cursor: "pointer",
                                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                    }}
                              >
                                    <StoreIcon
                                          sx={{
                                                fontSize: {
                                                      sm: "2.5vh",
                                                      md: "4vh",
                                                },
                                          }}
                                    />
                              </Box>

                              <Box
                                    sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "flex-start",
                                          gap: "0.2vh",
                                          justifyContent: "center",
                                          minWidth: 0,
                                          flex: 1,
                                    }}
                              >
                                    <Typography
                                          sx={{
                                                fontSize: {
                                                      sm: "0.82rem",
                                                      md: "0.9rem",
                                                },
                                                fontWeight: "bold",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: "100%",
                                          }}
                                    >
                                          {selectedSite.name}
                                    </Typography>

                                    <Typography
                                          sx={{
                                                fontSize: {
                                                      sm: "0.62rem",
                                                      md: "0.7rem",
                                                },
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: "100%",
                                          }}
                                    >
                                          {selectedSite.location}
                                    </Typography>

                                    <Typography
                                          sx={{
                                                fontSize: {
                                                      sm: "0.47rem",
                                                      md: "0.5rem",
                                                },
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: "100%",
                                          }}
                                    >
                                          {selectedSite.id}
                                    </Typography>
                              </Box>
                        </Box>

                        <Box
                              sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: 1.5,
                                    flexShrink: 0,
                                    alignSelf: "center",
                                    pl: 0,
                              }}
                        >
                              <Box
                                    sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "flex-start",
                                          justifyContent: "flex-start",
                                          textAlign: "start",
                                    }}
                              >
                                    <Typography
                                          sx={{
                                                fontSize: {
                                                      sm: "0.82rem",
                                                      md: "0.9rem",
                                                },
                                                fontWeight: "bold",
                                                color: "rgb(90, 28, 47)",
                                                lineHeight: 1.3,
                                          }}
                                    >
                                          Welcome to the world of digital labels!
                                    </Typography>

                                    <Typography
                                          sx={{
                                                fontSize: {
                                                      sm: "0.65rem",
                                                      md: "0.7rem",
                                                },
                                                color: "rgb(90, 28, 47)",
                                                lineHeight: 1.3,
                                          }}
                                    >
                                          This is what smart sustainability looks like.
                                    </Typography>
                              </Box>
                        </Box>
                  </Box>
            </>
      );
}

export default TruInkSelectedSiteHeader